(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filtration"] && !Shopify.designMode) return;
  try {
    
  class SectionSort extends HTMLElement {
    constructor() {
      super();
      this.select = this.querySelector('select');
      this.sections = document.querySelectorAll('[data-section-tag]');
    }

    connectedCallback() {
      if (!this.select) return;

      this.filterSections();
      this.select.addEventListener('change', this.filterSections.bind(this));
    }

    filterSections() {
      const value = this.select.value;

      this.sections.forEach((section) => {
        const tag = section.getAttribute('data-section-tag');
        section.style.display = !value || tag === value ? '' : 'none';
      });
    }
  }

  customElements.define('section-sort', SectionSort);

  } catch(e) { console.error(e); }
})();
})();
